import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/internal/operators/catchError';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

export const mainInterceptor: HttpInterceptorFn = (req, next) => {
	const authorizedUrls = [environment.apiAuthUrl, environment.apiClippingUrl, environment.apiClientUrl, environment.apiAiHubUrl, environment.apiContractNotices, environment.apiNotification, environment.apiTranscription];
	const permittedUrls = [`${environment.apiAuthUrl}/v1/password`, `${environment.apiAuthUrl}/v1/auth`];
	const reportsUrl = ['/pdf', '/export'];

	const authService = inject(AuthenticationService);
	if (authorizedUrls.some(url => req.url.includes(url)) && permittedUrls.every(url => !req.url.includes(url))) {
		const loginData = authService.loginData.getValue();
		const accessToken = loginData && Object.keys(loginData).length ? loginData.accessToken : '';
		const headers = accessToken ? req.headers.set('Authorization', 'Bearer ' + accessToken) : req.headers.delete('Authorization');

		if (reportsUrl.some(urlPart => req.url.includes(urlPart))) {
			req = req.clone({
				headers,
				responseType: 'blob' as any | Blob,
			});
		} else {
			req = req.clone({
				headers,
			});
		}
	}

	return next(req).pipe(
		catchError(error => {
			if (error instanceof HttpErrorResponse) {
				if (error.status === 401) {
					authService.userLogout('Access token expired');
				}
			}
			throw error;
		})
	);
};
